import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VesselService {

  constructor(private http: HttpClient) {}

  getByName(vessel: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}vessel/v1?vesselName=${vessel}`);
  }

  getDistinctName(vessel: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}vessel/v1/distinct-name?vesselName=${vessel}`);
  }

  getNoLink(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}vessel/v1/no-link`);
  }

  getLink(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}vessel/v1/link`);
  }

  saveMyFleet(body: any): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupUrl}vessel/v1/myfleet`, body);
  }

  deleteMyFleet(id): Observable<any> {
    return this.http.delete<any>(`${environment.apis.lineupUrl}vessel/v1/myfleet/${id}`);
  }

  getMyFleetCalls(terminalid) {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}my-fleet/v1/calls/${terminalid}`);

  }
}